import React, { useState, useEffect, Fragment } from 'react';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import useParticipants from '../../hooks/useParticipants/useParticipants';
import { RemoteAudioTrackPublication, RemoteParticipant } from 'twilio-video';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { ParticipantAudioTracks } from '../ParticipantAudioTracks/ParticipantAudioTracks';
import { LocalAudioTrack, LocalVideoTrack, Participant, RemoteAudioTrack, RemoteVideoTrack } from 'twilio-video';
import usePublications from '../../hooks/usePublications/usePublications';
import useIsTrackSwitchedOff from '../../hooks/useIsTrackSwitchedOff/useIsTrackSwitchedOff';
import useTrack from '../../hooks/useTrack/useTrack';
import useTracks from '../../hooks/useTracks/useTracks';
import clsx from 'clsx';
import useIsTrackEnabled from '../../hooks/useIsTrackEnabled/useIsTrackEnabled';
import AudioLevelIndicator from '../AudioLevelIndicator/AudioLevelIndicator';
import useChatContext from '../../hooks/useChatContext/useChatContext';
import Mic from '../Assets/mic.png';
import { useHistory } from 'react-router-dom';
import Disconnect from '../Assets/disconnect.png';
import Videos from '../Assets/video.png';
import MutedVideo from '../Assets/MutedVideo.png';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
function ParticipantAudioMuteUnMute({ participant }: { participant: RemoteParticipant }) {
  const { messages, conversation } = useChatContext();
  const { URLRoomName } = useParams<{ URLRoomName?: string }>();
  const { search, state } = useLocation();
  const [roomName, setRoomName] = useState<string>('');
  useEffect(() => {
    if (URLRoomName) {
      setRoomName(URLRoomName);
      // if (state) {
      //   const ContactPhoneNumber = (state as { state: { ContactPhoneNumber: string } }).state.ContactPhoneNumber;
      //   const RecordId = (state as { state: { RecordId: string } }).state.RecordId;
      //   const ContactName = (state as { state: { ContactName: string } }).state.ContactName;
      //   const ProviderId = (state as { state: { ProviderId: string } }).state.ProviderId;
      //   const Type = (state as { state: { Type: string } }).state.Type;
      //   const providerName = (state as { state: { providerName: string } }).state.providerName;
      // }
    }
  }, [URLRoomName]);
  // console.log(URLRoomName, "URLRoomName")
  // const { search, state } = useLocation();
  const MuteParticipant = (MuteUser: string) => {
    conversation?.sendMessage(`muted/${MuteUser}`);
  };
  const DisconnectParticipant = (DisconnectUser: string) => {
    conversation?.sendMessage(`disconnected/${DisconnectUser}`);
  };
  const DisconnectParticipantV2 = async (DisconnectUser: string, DisconnectUserId: string) => {
    // console.log(URLRoomName, DisconnectUser)
    conversation?.sendMessage(`disconnected/${DisconnectUserId}`);
    const response = await axios.get(
      `https://avserver.jobsitecare.com/removeparticpant/${URLRoomName}/${DisconnectUser}`
    );
  };
  const HideVideo = (DisconnectUser: string) => {
    conversation?.sendMessage(`video/${DisconnectUser}`);
  };
  const tracks = useTracks(participant);
  //console.log(tracks, 'participant ka track');
  const audioTrack = tracks.find(track => track.kind === 'audio') as RemoteAudioTrack | undefined;
  const videoTrack = tracks.find(track => track.kind === 'video') as RemoteVideoTrack | undefined;
  //console.log(videoTrack, 'videoTrack');
  //console.log(tracks, 'check');
  //console.log(audioTrack, 'audiocheck');
  const isTrackEnabled = useIsTrackEnabled(audioTrack as LocalAudioTrack | RemoteAudioTrack);
  if (audioTrack?.kind === 'audio') {
    //console.log(isTrackEnabled, 'isTrackEnabled');
    if (audioTrack?.isEnabled == true) {
      return (
        <>
          <div className="col-sm-5 discbtn">
            <button onClick={() => MuteParticipant(participant.sid)}>
              <img src={Mic} alt="as" />
            </button>
            {videoTrack?.isEnabled == true ? (
              <button onClick={() => HideVideo(participant.sid)}>
                <img src={Videos} alt="as" />
              </button>
            ) : (
              <button onClick={() => HideVideo(participant.sid)}>
                <img src={MutedVideo} alt="as" />
              </button>
            )}

            <button onClick={() => DisconnectParticipantV2(participant.identity, participant.sid)}>
              <img src={Disconnect} alt="as" />
            </button>
          </div>
        </>
      );
    } else if (audioTrack?.isEnabled == false) {
      return (
        <>
          <div className="col-sm-5 discbtn">
            <button onClick={() => MuteParticipant(participant.sid)}>
              <img src={Mic} alt="as" />
            </button>
            {videoTrack?.isEnabled == true ? (
              <button onClick={() => HideVideo(participant.sid)}>
                <img src={Videos} alt="as" />
              </button>
            ) : (
              <button onClick={() => HideVideo(participant.sid)}>
                <img src={MutedVideo} alt="as" />
              </button>
            )}
            <button onClick={() => DisconnectParticipantV2(participant.identity, participant.sid)}>
              <img src={Disconnect} alt="as" />
            </button>
          </div>
        </>
      );
    }
  }

  return <></>;

  // return (
  //   <button onClick={() => MuteParticipant(participant.sid)} className="unmute">
  //     Mute
  //   </button>
  // );
}
// function ShowHideVideo(
//   {participant}: {participant: RemoteParticipant }
// ) {
//   const { messages, conversation } = useChatContext();
//   const ShowVideoParticipants = (VideoUser: string) => {
//     conversation?.sendMessage(`showvideo/${VideoUser}`);
//   };
// }

function ParticipantAudio({ participant }: { participant: RemoteParticipant }) {
  const tracks = useTracks(participant);
  const audioTrack = tracks.find(track => track.kind === 'audio') as RemoteAudioTrack | undefined;
  //console.log(tracks, 'check');
  //console.log(audioTrack, 'audiocheck');
  if (audioTrack?.kind === 'audio') return <AudioLevelIndicator audioTrack={audioTrack} />;

  return null;
}
// function ParticipantVideo() {

// }
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chatWindowContainer: {
      background: '#FFFFFF',
      zIndex: 9,
      display: 'flex',
      flexDirection: 'column',
      borderLeft: '1px solid #E4E7E9',
      [theme.breakpoints.down('sm')]: {
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 100,
      },
    },
    hide: {
      display: 'none',
    },
  })
);
export default function ParticipantsList() {
  const classes = useStyles();
  const history = useHistory();
  const { search, state } = useLocation();
  const ContactPhoneNumber = (state as { state: { ContactPhoneNumber: string } }).state.ContactPhoneNumber;
  const RecordId = (state as { state: { RecordId: string } }).state.RecordId;
  const ContactName = (state as { state: { ContactName: string } }).state.ContactName;
  const ProviderId = (state as { state: { ProviderId: string } }).state.ProviderId;
  const Type = (state as { state: { Type: string } }).state.Type;
  const participantses = useParticipants();
  const { room } = useVideoContext();
  const [participants, setParticipants] = useState(Array.from(room?.participants.values() ?? []));
  const [Audio, SetAudio] = useState<any>(undefined);

  const { messages, conversation } = useChatContext();
  const LoadParticipantAudioTrack = (participant: any) => {
    const publications = usePublications(participant);
    //console.log(publications, 'ddd');
    const audioPublication = publications.find(p => p.kind === 'audio');
    const audioTrack = useTrack(audioPublication) as LocalAudioTrack | RemoteAudioTrack | undefined;
    //console.log(audioTrack);
    return audioTrack;
  };
  // const LoadVideoParticipant = (participant: any) => {
  //   //console.log("chala")
  //   const publications = usePublications(participant);
  //   // const audioPublication = publications.find(p => p.kind === 'audio');
  //   // const videoPublication = publications.find(p => !p.trackName.includes('screen') && p.kind === 'video');

  //   // const isVideoEnabled = Boolean(videoPublication);
  //   // const isScreenShareEnabled = publications.find(p => p.trackName.includes('screen'));

  //   // const videoTrack = useTrack(videoPublication);
  //   // const isVideoSwitchedOff = useIsTrackSwitchedOff(videoTrack as LocalVideoTrack | RemoteVideoTrack);
  //   // return videoTrack;
  // }
  // const AudioTracksFunction = (audio: Entries) => {
  //   cons
  //   return audio;
  // }
  const CheckAudioIndicator = (participant: []) => {
    // AudioTracksFunction(participant.audioTracks)
    // //console.log(participant.audioTracks[0])
    //console.log(participant);
    // return (<button onClick={() => MuteParticipant(participant.sid)}>Mute</button>)
    // if (participant?.audioTracks) {
    //   if (participant?.audioTracks[0]?.Entries.RemoteAudioTrackPublication.value.isTrackEnabled == "false") {
    //     return false
    //   }
    // }
    // else {
    //   return true
    // }
  };
  const MuteParticipant = (MuteUser: string) => {
    conversation?.sendMessage(`muted/${MuteUser}`);
  };

  useEffect(() => {
    if (room) {
      //console.log(messages, 'messages');
      //console.log(conversation, 'conversation');
      // const Data = Array.from(room?.participants.values(), p => ({
      //     participant: p.identity,
      //     dominantSpeakerStartTime: 0,
      // }))

      // setParticipants(Array.from(room.participants.values()));
      const participantConnected = (participant: RemoteParticipant) =>
        setParticipants(prevParticipants => [...prevParticipants, participant]);
      const participantDisconnected = (participant: RemoteParticipant) =>
        setParticipants(prevParticipants => prevParticipants.filter(p => p !== participant));
      room.on('participantConnected', participantConnected);
      room.on('participantDisconnected', participantDisconnected);
      //console.log(participants, 'audiolevel');

      participants.map(item => {
        return; //console.log(item);
      });
      // LoadVideoParticipant(room?.localParticipant)
      // room.on("participantConnected",)
    }
  }, [room]);

  return (
    <div className={clsx(classes.chatWindowContainer)} id="partss">
      <div className="mepeoples row">
        <div className="col-sm-6">
          <h3>1.{room?.localParticipant.identity}(You)</h3>
        </div>

        <div className="col-sm-6">
          <h3>
            <AudioLevelIndicator audioTrack={LoadParticipantAudioTrack(room?.localParticipant)} />
          </h3>
        </div>
      </div>

      {// participantss && participantss.map((singleparticipants) => {

      // })
      participants &&
        participants.map((item, i) => {
          return (
            <div className="mepeoples row">
              <div className="col-sm-6">
                <h3>
                  {i + 2}. {item.identity}
                </h3>
              </div>

              <div className="col-sm-1">
                <h3>
                  <ParticipantAudio key={item.sid} participant={item} />
                  {/* {
                  <h3>
                    {' '}
                    <AudioLevelIndicator audioTrack={LoadParticipantAudioTrack(item)} />
                  </h3>
                } */}
                </h3>
              </div>
              {Type == 'Host' ? <ParticipantAudioMuteUnMute key={item.sid} participant={item} /> : <></>}

              {/* <button onClick={() => MuteParticipant(item.sid)}>Mute</button> */}
              {/* {
                  CheckAudioIndicator(item) ? <button onClick={() => MuteParticipant(item.sid)}>Mute</button> : <button onClick={() => MuteParticipant(item.sid)}>Mute</button>
                } */}
              {/* {
                  CheckAudioIndicator(Array.from(item.audioTracks))
                } */}
            </div>
          );
        })}
    </div>
  );
}
